import { getBffUrl as bffUrlSelector } from 'selectors'
import store from '../store'

import * as Api from '../utils/api'

const getBffUrl = () => bffUrlSelector(store.getState())

export const fetchContacts = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/search`,
  body
)

export const countContacts = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/search/total`,
  body
)

export const fetchContactIds = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/search/ids`,
  body
)

export const deleteContacts = ids => Api.destroy(
  `${getBffUrl()}/contacts_management/contacts`,
  { ids }
)

export const createDistributionList = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists`,
  body
)

export const deleteDistributionLists = ids => Api.destroy(
  `${getBffUrl()}/contacts_management/distribution_lists`,
  { ids }
)

export const updateDistributionList = body => Api.patch(
  `${getBffUrl()}/contacts_management/distribution_lists/${body.id}`,
  body
)

export const exportDistributionList = body => (
  Api.post(
    `${getBffUrl()}/contacts_management/distribution_lists/export`,
    body,
    'blob'
  )
)

export const mergeDistributionLists = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/merge`,
  body
)

export const fetchDistributionLists = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/search`,
  body
)

export const fetchDistributionListIds = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/search/ids`,
  body
)

export const fetchContactById = contactId => Api.get(
  `${getBffUrl()}/contacts_management/contacts/${contactId}`
)

export const createContact = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts`,
  body
)

export const updateContact = (id, body) => Api.patch(
  `${getBffUrl()}/contacts_management/contacts/${id}`,
  body
)

export const resetContact = (id, body) => Api.post(
  `${getBffUrl()}/contacts_management/contacts/${id}/reset`,
  body
)

export const fetchEmailEventsByContactId = (contactId, body) => Api.post(
  `${getBffUrl()}/contacts_management/contacts/${contactId}/email_events`,
  body
)

export const fetchEarnedMediaByContactId = (contactId, body) => Api.post(
  `${getBffUrl()}/contacts_management/contacts/${contactId}/earned_media`,
  body
)

export const sendErrorReport = (contactId, body) => Api.post(
  `${getBffUrl()}/contacts_management/contacts/${contactId}/report_error`,
  body
)

export const createListAndAddContacts = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/create_list_and_add_contacts`,
  body
)

export const addContactsToDistributionLists = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/add_contacts`,
  body
)

export const removeContactsFromList = (id, body) => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/${id}/remove_contacts`,
  body
)

export const removeContactsFromDistributionLists = body => Api.post(
  `${getBffUrl()}/contacts_management/distribution_lists/remove_contacts`,
  body
)

export const importUploadFile = data => {
  const formData = new FormData()
  data.forEach(({ key, value }) => formData.append(key, value))

  return Api.form(
    `${getBffUrl()}/contacts_management/contacts/upload/initialize`, formData
  )
}

export const importSetup = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/upload/setup`,
  body
)

export const importFinalize = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/upload/finalize`,
  body
)

export const cleanupImportFile = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/upload/cleanup`,
  body
)

export const replaceContacts = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/upload/replace`, body
)

export const downloadFailed = data => (
  Api.post(
    `${getBffUrl()}/contacts_management/contacts/upload/download_failed`, data, 'blob'
  )
)

export const exportContacts = body => (
  Api.post(
    `${getBffUrl()}/contacts_management/contacts/export`,
    body,
    'blob'
  )
)

export const searchAnewstipJournalists = body => Api.post(
  `${getBffUrl()}/contacts_management/anewstip/search/journalists`, body
)

export const searchAnewstipOutlets = body => Api.post(
  `${getBffUrl()}/contacts_management/anewstip/search/outlets`, body
)

export const searchAnewstipArticles = body => Api.post(
  `${getBffUrl()}/contacts_management/anewstip/search/articles`, body
)

export const fetchAnewstipStatics = () => Api.get(
  `${getBffUrl()}/contacts_management/anewstip/statics`
)

export const searchAnewstipSuggest = body => Api.post(
  `${getBffUrl()}/contacts_management/anewstip/suggest`, body
)

export const importAnewstipContacts = body => Api.post(
  `${getBffUrl()}/contacts_management/contacts/anewstip_import`, body
)

export const importSuggestedContact = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/import`, body
)
